import { ActionTypes } from '../types/action-types';
import { DATA_STATE } from '../types/demo';

export interface IDataHolder {
  result?: any,
  showResult?: boolean,
  state: DATA_STATE
}

export const getData = (): IDataHolder => {
  return {
    showResult: false,
    state: DATA_STATE.READY
  }
}

export default (state = getData(), action): IDataHolder => {
  const newState = {...state};
  switch (action.type) {
    case ActionTypes.DEMO_DATA_PENDING:
      newState.state = DATA_STATE.PROCESSING;
      break;
    case ActionTypes.DEMO_DATA_READY:
      newState.state = DATA_STATE.READY;
      newState.result = action.value;
      break;
    case ActionTypes.DEMO_SHOW_RESULT:
      newState.showResult = action.value;
      break;
  }
  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/demo.ts